import { getConciergeResponseSchema } from "@redotech/redo-model/concierge-conversation/rpc/concierge-conversation-schema";

export const getConciergeResponse = getConciergeResponseSchema;
